import axios from "axios";

export const baseSignApi = axios.create({
  baseURL: process.env.VUE_APP_SIGN_API,
  headers: {
    "Content-type": "application/json",
  },
});
